module.exports = __webpack_public_path__ + "static/img/1-1.f1d0be5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/1-1.jpg
// module id = 8mH4
// module chunks = 1